export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.kiao.voice.android'

// Taiwan App Store listing supplied for the homepage download CTA.
export const IOS_STORE_URL =
  'https://apps.apple.com/tw/app/kiao-voice-%E4%B8%AD%E6%96%87%E8%AA%9E%E9%9F%B3%E8%BC%B8%E5%85%A5/id6793500205'
